import React from "react"
import ToolTip from "react-portal-tooltip"
import { green500 } from "material-ui/styles/colors"
import {IconButton, FontIcon} from "material-ui"
import { IObjectAudit } from "../../models"
import AuditShow from "./AuditShow"

interface IProps {
    keyStr: string
    label: string
    audit: IObjectAudit
    fileId?: string
    fileName?: string
    onFileDownload?(): void
}

interface IState {
    open: boolean
}

export default class ApprovedIcon extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            open: false
        }
    }

    render() {
        return (
            <div>
                <ToolTip active={this.state.open} position="bottom" arrow="center" parent={"#" + "approved-" + this.props.keyStr}>
                    <div style={{ paddingLeft: 15, paddingRight: 15, textAlign: "center" }}>
                        <AuditShow
                            label={this.props.label}
                            audit={this.props.audit}
                        />
                        {this.props.fileId &&
                            <div>   
                                <IconButton data-intercom-target={"menu-Payroll-Btn-DownloadPayrollFile"} tooltip={this.props.fileName} onTouchTap={this.props.onFileDownload}>
                                    <FontIcon className="fa fa-download" style={{ fontSize: 20, marginRight: 20 }} />
                                </IconButton>                                
                                Download Payroll Export File
                            </div>
                        }
                    </div>
                </ToolTip>
                <div style={{ marginTop: -5, fontSize: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    <i
                        id={"approved-" + this.props.keyStr}
                        className="fa fa-check"
                        style={{ fontSize: 22, color: green500 }}
                        onMouseOver={() => this.setState({ open: true })}
                        onMouseOut={() => this.setState({ open: false })}
                    />                    
                </div>
            </div>
        )
    }
}